import { useState, useCallback } from "react";
import { Button, Input } from "@aidkitorg/component-library";
import { usePost } from "../../../API";
import { useLocalizedStrings } from "../../../Localization";
import { useConnectionModal } from "./ConnectionModalContext";
import { SourceHeader } from "./SourceHeader";
import { type ConnectionModalState } from "./types";

interface ConnectionModalAdditionalQuestionPageProps {
  state: ConnectionModalState & { stage: "additional_question" };
}

export function ConnectionModalAdditionalQuestionPage({
  state,
}: ConnectionModalAdditionalQuestionPageProps) {
  const L = useLocalizedStrings();
  const answerAdditionalQuestion = usePost("/deck/answer_additional_question");
  const { onUpdateState, onExit } = useConnectionModal();

  const [answer, setAnswer] = useState("");

  const handleChangeAnswer = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setAnswer(e.currentTarget.value);
  }, []);

  const handleClickSubmit = useCallback(async () => {
    await answerAdditionalQuestion({
      job_guid: state.jobGuid,
      answer,
    });

    onUpdateState({
      stage: "pending",
      selectedSource: state.selectedSource,
      jobGuid: state.jobGuid,
    });
  }, [answer, state]);

  return <div>
    <SourceHeader source={state.selectedSource} />
    <Input
      label={state.question}
      value={answer}
      onChange={handleChangeAnswer}
      dir="ltr" // This question from Deck will always be in English
    />
    <div className="mt-6 flex justify-between">
      <Button onClick={onExit} variant="secondary">
        {L.component_library.modal.close}
      </Button>
      <Button onClick={handleClickSubmit} variant="primary">
        {L.submission.submit}
      </Button>
    </div>
  </div>
}
